import { useEffect, useState } from "react";
import { useParams } from "react-router";
import type { PreviewSeed } from "@contracts/types";
import { CarouselApp } from "@/components/CarouselApp";

export default function PreviewPage() {
  const { id = "" } = useParams<{ id: string }>();
  const [preview, setPreview] = useState<PreviewSeed | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    fetch(`/api/share/${encodeURIComponent(id)}`, { cache: "no-store" })
      .then(async (response) => {
        if (!response.ok) {
          const result = await response.json().catch(() => null) as { error?: string } | null;
          throw new Error(result?.error || "Preview unavailable");
        }
        return response.json() as Promise<PreviewSeed>;
      })
      .then((data) => {
        if (active) setPreview(data);
      })
      .catch((reason: unknown) => {
        if (active) {
          setPreview(null);
          setError(reason instanceof Error ? reason.message : "Preview unavailable");
        }
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [id]);

  if (loading) {
    return (
      <main className="unavailable-preview">
        <span className="section-kicker">THIS IS HOW YOUR POST WILL LOOK</span>
        <h1>Loading preview…</h1>
      </main>
    );
  }

  if (!preview) {
    return (
      <main className="unavailable-preview">
        <span className="section-kicker">THIS IS HOW YOUR POST WILL LOOK</span>
        <h1>{error === "Link expired" ? "Link expired." : "This preview is no longer available."}</h1>
        {error !== "Link expired" && <p>Check the URL or ask the person who shared it for an updated link.</p>}
      </main>
    );
  }

  return <CarouselApp initialPreview={preview} />;
}
